import { GALLERY } from '@/globalVariables'

import { StageType } from '@/interfaces/Tutorial'
import type { TutorialStage } from '@/interfaces/Tutorial'

/**
  Tutorial for unlocked mechanic GALLERY
 */

export default class TutorialUnlockGallery {
  stages(): TutorialStage[] {
    return [
      // narative saying you unlocked a new mechanic - gallery
      {
        name: 'unlockGalleryNarrative',
        type: StageType.Narrative,
        overlay: false,
        mechanic: 11,
        pageName: 'LayoutViewTutorial',
        texts: [],
      },
      // focus on tutorial building
      {
        name: 'clickOnGalleryBuilding',
        type: StageType.Focus,
        mechanic: 11,
        overlay: false,
        pageName: 'LayoutViewTutorial',
        clientId: [GALLERY],
        texts: [],
      },
    ]
  }
}
